export enum Sort {
    discountHighToLow = 'discount-high-to-low',
    discountLowToHigh = 'discount-low-to-high',
    priceHighToLow = 'price-high-to-low',
    priceLowToHigh = 'price-low-to-high',
}